import { ProductScreenshot } from 'components/ProductScreenshot';
import { CalloutBox } from 'components/Docs/CalloutBox';
import QueryJoinExample from "../../../../contents/docs/data-warehouse/_snippets/query-join-example.mdx";
import * as React from 'react';
export default {
  ProductScreenshot,
  CalloutBox,
  QueryJoinExample,
  React
};